export const AvaxLogo = () => (
	<svg
		width="25"
		height="25"
		viewBox="0 0 30 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z"
			fill="#E84142"
		/>
		<path
			d="M20.2914 15.3898C20.8111 14.4921 21.6497 14.4921 22.1693 15.3898L25.4056 21.0709C25.9252 21.9685 25.5 22.7008 24.4607 22.7008H17.941C16.9134 22.7008 16.4882 21.9685 16.9961 21.0709L20.2914 15.3898ZM14.0315 4.45277C14.5512 3.55513 15.378 3.55513 15.8977 4.45277L16.6182 5.75198L18.3189 8.74017C18.7323 9.59056 18.7323 10.5945 18.3189 11.4449L12.6142 21.3307C12.0945 22.1339 11.2323 22.6417 10.2756 22.7008H5.53942C4.50005 22.7008 4.07485 21.9803 4.59454 21.0709L14.0315 4.45277Z"
			fill="white"
		/>
	</svg>
);

export const BSCLogo = () => (
	<svg
		width="25"
		height="25"
		viewBox="0 0 30 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z"
			fill="#F3BA2F"
		/>
		<path
			d="M11.3588 13.5038L15 9.8625L18.6431 13.5056L20.7619 11.3869L15 5.625L9.24 11.385L11.3588 13.5038ZM5.625 15L7.74375 12.8812L9.8625 15L7.74375 17.1188L5.625 15ZM11.3588 16.4963L15 20.1375L18.6431 16.4944L20.7619 18.6122L15 24.375L9.24 18.615L9.23719 18.6122L11.3588 16.4963ZM20.1375 15L22.2563 12.8812L24.375 15L22.2563 17.1188L20.1375 15ZM17.1488 14.9981H17.1506V15L15 17.1506L12.8522 15.0037L12.8484 15L12.8522 14.9972L13.2281 14.6203L13.4109 14.4375L15 12.8494L17.1497 14.9991L17.1488 14.9981Z"
			fill="white"
		/>
	</svg>
);

export const ETHLogo = () => (
	<svg
		width="25"
		height="25"
		viewBox="0 0 30 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z"
			fill="#627EEA"
		/>
		<path
			d="M15.0294 3.75V12.0656L22.0578 15.2062L15.0294 3.75Z"
			fill="white"
			fillOpacity="0.602"
		/>
		<path d="M15.0294 3.75L8 15.2062L15.0294 12.0656V3.75Z" fill="white" />
		<path
			d="M15.0294 20.595V26.2453L22.0625 16.515L15.0294 20.595Z"
			fill="white"
			fillOpacity="0.602"
		/>
		<path d="M15.0294 26.2453V20.594L8 16.515L15.0294 26.2453Z" fill="white" />
		<path
			d="M15.0294 19.2872L22.0578 15.2063L15.0294 12.0675V19.2872Z"
			fill="white"
			fillOpacity="0.2"
		/>
		<path
			d="M8 15.2063L15.0294 19.2872V12.0675L8 15.2063Z"
			fill="white"
			fillOpacity="0.602"
		/>
	</svg>
);

export const PolygonLogo = () => (
	<svg
		width="25"
		height="25"
		viewBox="0 0 30 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 10C0 4.47715 4.47715 0 10 0H20C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10Z"
			fill="#8247E5"
		/>
		<path
			d="M20.4896 11.5015C20.1157 11.2878 19.635 11.2878 19.2077 11.5015L16.2166 13.2641L14.1869 14.3858L11.2493 16.1484C10.8754 16.362 10.3947 16.362 9.96736 16.1484L7.67062 14.7596C7.29674 14.546 7.02967 14.1187 7.02967 13.638V10.9674C7.02967 10.5401 7.24332 10.1128 7.67062 9.8457L9.96736 8.51039C10.3412 8.29674 10.822 8.29674 11.2493 8.51039L13.546 9.89911C13.9199 10.1128 14.1869 10.5401 14.1869 11.0208V12.7834L16.2166 11.6083V9.79228C16.2166 9.36499 16.003 8.93769 15.5757 8.67062L11.3027 6.16024C10.9288 5.94659 10.4481 5.94659 10.0208 6.16024L5.64095 8.72404C5.21365 8.93769 5 9.36499 5 9.79228V14.8131C5 15.2404 5.21365 15.6677 5.64095 15.9347L9.96736 18.4451C10.3412 18.6588 10.822 18.6588 11.2493 18.4451L14.1869 16.7359L16.2166 15.5608L19.1543 13.8516C19.5282 13.638 20.0089 13.638 20.4362 13.8516L22.7329 15.1869C23.1068 15.4006 23.3739 15.8279 23.3739 16.3086V18.9792C23.3739 19.4065 23.1602 19.8338 22.7329 20.1009L20.4896 21.4362C20.1157 21.6499 19.635 21.6499 19.2077 21.4362L16.911 20.1009C16.5371 19.8872 16.27 19.4599 16.27 18.9792V17.27L14.2404 18.4451V20.2077C14.2404 20.635 14.454 21.0623 14.8813 21.3294L19.2077 23.8398C19.5816 24.0534 20.0623 24.0534 20.4896 23.8398L24.816 21.3294C25.1899 21.1157 25.457 20.6884 25.457 20.2077V15.1335C25.457 14.7062 25.2433 14.2789 24.816 14.0119L20.4896 11.5015Z"
			fill="white"
		/>
	</svg>
);

export const EnergiLogo = () => (
	<svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M64 120C97.1371 120 124 93.1371 124 60C124 26.8629 97.1371 0 64 0C30.8629 0 4 26.8629 4 60C4 93.1371 30.8629 120 64 120Z"
			fill="url(#paint0_linear)"
		/>
		<path
			d="M64.0131 19L88.9999 44.3222L64.0018 69.6291L54.0011 59.5065L69.0012 44.3222L64.0018 39.2597L44.0004 59.5065L64.0018 79.7532L94.0011 49.3823L104 59.5065L64.0017 100L24 59.5065L64.0131 19Z"
			fill="#212121"
		/>
		<path
			d="M64 118C96.0325 118 122 92.0325 122 60C122 27.9675 96.0325 2 64 2C31.9675 2 6 27.9675 6 60C6 92.0325 31.9675 118 64 118Z"
			stroke="black"
			stroke-opacity="0.097"
		/>
		<defs>
			<linearGradient
				id="paint0_linear"
				x1="64"
				y1="0"
				x2="64"
				y2="120"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#01E46F" />
				<stop offset="0.473745" stop-color="#01DE5D" />
				<stop offset="1" stop-color="#01D74A" />
			</linearGradient>
		</defs>
	</svg>
);
